import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'antd'
import { EyeTwoTone } from '@ant-design/icons'

/**
 * Khối "Mô tả QCHT" dùng chung cho cả 2 màn:
 * - Màn QC 1 item (ItemQCnotMask)
 * - Màn QC nhiều item khi đơn chỉ có 1 item (ListItemsQC)
 *
 * Gộp markup + modal preview ảnh vào 1 chỗ để 2 màn không giữ 2 bản riêng rồi lệch nhau.
 *
 * descriptions PHẢI là kết quả của resolveBrandDescriptions - helper đã normalize
 * description: '' và images: [] nên .map bên dưới an toàn.
 */
class QchtDescriptionBox extends Component {
    state = {
        previewImage: '',
    }

    //Trả focus về ô quét barcode sau khi đóng preview: màn QC hoàn thành chỉ thao tác bằng súng scan,
    //click icon con mắt làm blur input và rc-dialog focus lại chính span icon (đang display:none)
    //nên lần bắn scan kế tiếp sẽ rơi vào body nếu không tự focus lại.
    _onClosePreview = () => {
        this.setState({ previewImage: '' }, this._notifyClosePreview)
    }

    _notifyClosePreview = () => {
        const { onClosePreview } = this.props

        if (typeof onClosePreview === 'function') onClosePreview()
    }

    //Đóng preview khi ảnh đang xem không còn thuộc dữ liệu hiện tại (dữ liệu đơn đổi dưới chân
    //modal đang mở - xảy ra khi response _handleGetDataMark của barcode mới về trong lúc QC viên
    //đang xem ảnh của đơn cũ). Nếu không reset, Modal giữ nguyên ảnh của ĐƠN TRƯỚC.
    //So theo NỘI DUNG chứ không so identity: hàm này không có guard prevProps nên chạy ở MỌI update
    //(kể cả setState của chính nó), và descriptions được tạo mới mỗi lần render vì
    //resolveBrandDescriptions được gọi trong render của cả 2 caller -> so identity sẽ tự đóng preview
    //ở mọi lần cha re-render.
    //Giới hạn đã biết: khối DEFAULT dùng chung URL ảnh giữa các đơn nên stillListed có thể vẫn true.
    componentDidUpdate() {
        const { previewImage } = this.state
        const { descriptions } = this.props
        const safeList = Array.isArray(descriptions) ? descriptions : []
        const stillListed = safeList.some(i => !!i && (Array.isArray(i.images) ? i.images : []).includes(previewImage))

        if (!!previewImage && !stillListed) this._onClosePreview()
    }

    //Đường KHÁC với componentDidUpdate ở trên: caller ListItemsQC gate bằng
    //!!inlineDescriptions.length nên khi hết mô tả nó unmount hẳn component này (còn caller
    //ItemQCnotMask render vô điều kiện nên đi qua componentDidUpdate). Unmount lúc preview đang mở
    //thì onCancel không chạy và rc-dialog cũng không restore focus (chỉ chạy khi Dialog còn sống)
    //-> focus rơi về body. Chỉ gọi callback, KHÔNG setState (component đang unmount).
    componentWillUnmount() {
        const { previewImage } = this.state

        if (!!previewImage) this._notifyClosePreview()
    }

    render() {
        const { previewImage } = this.state
        const { descriptions, className } = this.props

        if (!Array.isArray(descriptions) || !descriptions.length) return null

        return (
            <div className={`MarkPackagedPageSpecifications ${className}`}>
                <div className="BoxContent">
                    <div className='font-weight-bold h5' style={{ color: 'crimson' }}>Mô tả QCHT</div>
                    {
                        descriptions.map(brandDescription => (
                            <div className="brand-description mb-2" key={`qcht_${brandDescription.brand}`}>
                                {
                                    !!brandDescription.brand &&
                                    <div className="brand-name">{brandDescription.brand}</div>
                                }
                                {
                                    !!brandDescription.description &&
                                    <div className="description">
                                        <pre>{brandDescription.description}</pre>
                                    </div>
                                }
                                <div className="images">
                                    {
                                        brandDescription.images.map((i, index) => (
                                            <div className="image-item" key={`qcht_${brandDescription.brand}_image_${index}`}>
                                                <img src={i} alt="preview" />
                                                <EyeTwoTone
                                                    className='eyes-image-item'
                                                    onClick={() => {
                                                        this.setState({
                                                            previewImage: i,
                                                        })
                                                    }}
                                                />
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
                <Modal
                    visible={!!previewImage}
                    title={'Preview image'}
                    footer={null}
                    onCancel={this._onClosePreview}
                >
                    <img
                        alt="preview"
                        style={{ width: '100%' }}
                        src={previewImage}
                    />
                </Modal>
            </div>
        )
    }
}

QchtDescriptionBox.propTypes = {
    descriptions: PropTypes.array.isRequired,
    className: PropTypes.string,
    onClosePreview: PropTypes.func,
}

QchtDescriptionBox.defaultProps = {
    //giữ đúng margin đang chạy ở ItemQCnotMask
    className: 'mt-2',
}

export default QchtDescriptionBox
